import { render, staticRenderFns } from "./_OrderProductAuction.vue?vue&type=template&id=924945fe&scoped=true&"
import script from "./_OrderProductAuction.vue?vue&type=script&lang=js&"
export * from "./_OrderProductAuction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "924945fe",
  null
  
)

export default component.exports